import { render, staticRenderFns } from "./animationsItemParticipants.vue?vue&type=template&id=4fdd31db&"
import script from "./animationsItemParticipants.vue?vue&type=script&lang=js&"
export * from "./animationsItemParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports